import type { AxiosError, AxiosInstance } from "axios";

export function getContentTypeBySlugBuilder(apiClient: AxiosInstance) {
  return async function getContentTypeBySlug(slug: string): Promise<any> {
    try {
      const response = await apiClient.post("/v2/pages/get-by-slug/", { slug });
      return response.data;
    } catch (error: unknown) {
      if (
        (error as AxiosError).response?.status === 404 ||
        (error as AxiosError).response?.status === 400
      ) {
        return null;
      } else {
        throw error;
      }
    }
  };
}
